import { Injectable, effect, inject } from '@angular/core';
import { NotificationsService } from './notifications.service';

@Injectable({ providedIn: 'root' })
export class AppBadgeService {
  private readonly notifications = inject(NotificationsService);

  constructor() {
    if (typeof navigator === 'undefined' || !('setAppBadge' in navigator)) {
      return;
    }

    effect(() => {
      const count = this.notifications.unreadCount();
      const applied = count > 0 ? navigator.setAppBadge(count) : navigator.clearAppBadge();
      void applied.catch(() => undefined);
    });
  }
}
